import { lifecycle, compose } from 'recompose'

import withConnectionStatus from './withConnectionStatus'

const withConnectionDetection = compose(
  withConnectionStatus,
  lifecycle({
    componentDidMount() {
      window.addEventListener('offline', () => {
        this.props.setConnectionStatus('offline')
      })

      window.addEventListener('online', () => {
        this.props.setConnectionStatus('online')
      })
    }
  })
)

export default withConnectionDetection



// WEBPACK FOOTER //
// ./src/hocs/withConnectionDetection.js